export default __webpack_public_path__ + "static/media/sunshine_logo_white_text_small.07805711.png";